import './NavbarContent.scss';

import { Link } from 'react-router-dom';

import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import NavbarItems from 'organisms/Navbar/NavbarItems';

export default function NavbarContent() {
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;
  return (
    <div className="navbar">
      {!isMobile && (
        <Link to="/appointments" className="text-left">
          <Icon name="pawcare" style={{ width: 125, height: '100%' }} />
        </Link>
      )}
      <div className="navbar-items">
        <NavbarItems isMobile={isMobile} />
      </div>
    </div>
  );
}
